import { Container, ContainerGutter, Richtext } from '@volkswagen-onehub/components-core';
import React from 'react';
import { DisclaimerTextLegal } from '../../../shared/ui/disclaimer-text-legal';
import { HuchaDisclaimer1Text } from './hucha-disclaimers';

interface DisclaimerContentProps {
	fontSize?: string;
	showDisclaimerNumber?: boolean;
	textGutter?: ContainerGutter;
}

export const HuchaDisclaimer1Content = ({
	fontSize,
	showDisclaimerNumber = true,
	textGutter = ContainerGutter.static350,
}: DisclaimerContentProps): React.JSX.Element => {
	return (
		<Container wrap={'always'} gutter={textGutter}>
			<DisclaimerTextLegal fontSize={fontSize}>
				{showDisclaimerNumber && '1. '}
				<Richtext dangerouslyParseRawHTML markdown={HuchaDisclaimer1Text} />
			</DisclaimerTextLegal>
		</Container>
	);
};
